import React from 'react'
import WhiteOpciones from '../../../../media/felsv/WhiteOpciones.svg'
import {useDispatch} from 'react-redux'
import {bindActionCreators} from 'redux'
import {actionFacturacionEmision} from '../../../../actions/action-creators'
import {facturacionClearAll} from '../../../../actions/facturacion/facturacionEmision.actions'
import {useHistory} from 'react-router'
import { docsAsociadosReset } from '../../../../actions/documentos/documentos.actions'
import { handleRestartStateFormaPago } from '../../../../actions/forma-pago.actions'

const FooterFinalizacion = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const actionsFE = bindActionCreators(actionFacturacionEmision, dispatch)

  const nuevaFactura = async () => {
    history.push('/emitir-factura/formulario')
    dispatch(docsAsociadosReset())
    await dispatch(facturacionClearAll())
    await dispatch(handleRestartStateFormaPago())
  }

  return (
    <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell'>
      <div className='card'>
        <div className='w-layout-vflex card-content'>
          <div className='w-layout-hflex button-actions'>
            <div style={{width: '15%'}}></div>
            <div style={{width: '55%'}}></div>
            <button className='m button botton-footer' onClick={actionsFE.facturacionOpenMasOpciones}>
              <img src={WhiteOpciones} loading='lazy' alt='Opciones' />
              <div>Más opciones</div>
            </button>
            <button className='m button botton-footer' onClick={nuevaFactura}>
              <div>Nueva Factura</div>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FooterFinalizacion
